import Model from './Model'
import get from "lodash/get";
export default class Invoice extends Model {

    static VAT_RATE = 21
    static VAT_RATE_MULTIPLIER = 1.21
    resource()
    {
        return 'invoices'
    }

    get type_friendly() {
        return get(this.types.find(stat => stat.id === this.type), 'text')
    }

    get types() {
        return [{
            id: 'INVOICE',
            text: 'Factura Fiscala',
        }, {
            id: 'CANCELED',
            text: 'Factura anulata'
        }, {
            id: 'STORNO',
            text: 'Factura Storno'
        }];
    }

    get downloadEndpoint() {
        return `${this.endpoint()}/download`
    }

    get downloadRecipeEndpoint() {
        return `${this.endpoint()}/download-recipe`
    }

    get exportEndpoint() {
        return `${this.endpoint()}/export`
    }
}
